/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { DailyActivityMonitoringLogHeaderSummaryDto } from './dailyActivityMonitoringLogHeaderSummaryDto.schema';

export const IReadOnlyListOfDailyActivityMonitoringLogHeaderSummaryDto = zod.array(zod.lazy(() => DailyActivityMonitoringLogHeaderSummaryDto));

export type IReadOnlyListOfDailyActivityMonitoringLogHeaderSummaryDto = zod.input<typeof IReadOnlyListOfDailyActivityMonitoringLogHeaderSummaryDto>;
export type IReadOnlyListOfDailyActivityMonitoringLogHeaderSummaryDtoOutput = zod.output<typeof IReadOnlyListOfDailyActivityMonitoringLogHeaderSummaryDto>;
